import { hasAdminRole } from '@/types/auth'
import { useAuth } from '@/composables/useAuth'
import { useRoleStore } from '@/stores/roleStore'

/**
 * 初始化权限守卫
 * 在应用启动时加载用户的权限树和角色列表。
 */
export async function initPermissionGuard(): Promise<void> {
  const { state } = useAuth()

  // 仅管理员需要加载权限树和角色列表，普通用户跳过以避免请求 admin 接口触发 403
  if (!hasAdminRole(state.currentUser?.role)) return

  const roleStore = useRoleStore()

  // 加载权限树定义
  await roleStore.fetchPermissionTree()

  // 加载角色列表用于查找
  await roleStore.fetchRoles()
}
